import { render, staticRenderFns } from "./SpecifiedCertify.vue?vue&type=template&id=0cdc96de&scoped=true"
import script from "./SpecifiedCertify.vue?vue&type=script&lang=js"
export * from "./SpecifiedCertify.vue?vue&type=script&lang=js"
import style0 from "./SpecifiedCertify.vue?vue&type=style&index=0&id=0cdc96de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdc96de",
  null
  
)

export default component.exports